import styled from 'styled-components';

export const StyledContainer = styled('div')`
	height: calc(100% + 20px);
`;

export const StyledLegendContainer = styled('div')<{ isComputing: boolean }>`
	display: flex;
	padding: 9px;
	gap: 11px;
	color: #879ba2;
	align-items: center;
	opacity: ${props => (props.isComputing ? '1' : '0')};
`;
